import * as React from 'react';
import '../home/tabs/styles.css';
import {
  PageWrapper,
  ProfileEmail,
  ProfilePic,
  ProfileTextWrap,
  ProfileTitle,
  SideBarHeadWrap,
  SideBarWrap,
  TabIcon,
  TabStyle,
} from './styles';
import {
  AddNewStaff,
  AttendanceSheets,
  Dashboard,
  Payment,
  Settings,
  MissingCourseReport,
  SignedInvigilatorRecords,
} from './tabs';
import logo from '../../../assets/coe-logo.jpg';
import { AddStudent } from './tabs';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { AdminHomeLoader, IS_USER_LOGGED_IN } from '../../../components';
import { IsLoggedInQuery } from '../../../generated/graphql';
import { useQuery } from '@apollo/client';

export const AdminHome = (): JSX.Element => {
  const [tabIndex, setTabIndex] = React.useState(0);
  const [showAdditionalTabs, setShowAdditionalTabs] = React.useState(false);
  const navigate = useNavigate();
  const { loading } = useQuery<IsLoggedInQuery>(IS_USER_LOGGED_IN, {
    onCompleted: (_data) => {
      if (_data.isLoggedIn?.user === 'admin') {
        setShowAdditionalTabs(true);
      }
    },
  });

  React.useEffect(() => {
    const tabIndexFromLocalStorage = localStorage.getItem('admin-current-tab') || 0;
    setTabIndex(parseInt(tabIndexFromLocalStorage as string));
  }, []);

  const logout = (): void => {
    localStorage.setItem('coe-admin-token', '');
    localStorage.setItem('admin-current-tab', JSON.stringify(0));
    navigate('/admin/sign-in');
    window.location.reload();
  };

  if (loading) return <AdminHomeLoader />;

  return (
    <PageWrapper>
      <Helmet>
        <title>Home | CoE Exams Office</title>
        <meta
          name="admin-home"
          content="Home page for knust,
        college of engineering exams office"
        />
      </Helmet>
      <SideBarWrap>
        <SideBarHeadWrap>
          <ProfilePic src={logo} />
          <ProfileTextWrap>
            <ProfileTitle>Exams Officer</ProfileTitle>
            <ProfileEmail>examsofficer.coe@gmail.com</ProfileEmail>
          </ProfileTextWrap>
        </SideBarHeadWrap>
        <div className="flex flex-col justify-between">
          <TabStyle
            isActive={tabIndex === 0}
            onClick={() => {
              setTabIndex(0);
              localStorage.setItem('admin-current-tab', JSON.stringify(0));
            }}
          >
            <TabIcon className="fas fa-th-large" /> Dashboard
          </TabStyle>
          {showAdditionalTabs && (
            <TabStyle
              isActive={tabIndex === 1}
              onClick={() => {
                setTabIndex(1);
                localStorage.setItem('admin-current-tab', JSON.stringify(1));
              }}
            >
              <TabIcon className="fas fa-file-signature" /> Signed invigilators records
            </TabStyle>
          )}
          <TabStyle
            isActive={tabIndex === 2}
            onClick={() => {
              setTabIndex(2);
              localStorage.setItem('admin-current-tab', JSON.stringify(2));
            }}
          >
            <TabIcon className="far fa-clipboard" /> Student{"'"}s attendance sheet
          </TabStyle>
          <TabStyle
            isActive={tabIndex === 3}
            onClick={() => {
              setTabIndex(3);
              localStorage.setItem('admin-current-tab', JSON.stringify(3));
            }}
          >
            <TabIcon className="fas fa-user-plus" /> Add Student
          </TabStyle>
          {showAdditionalTabs && (
            <TabStyle
              isActive={tabIndex === 6}
              onClick={() => {
                setTabIndex(6);
                localStorage.setItem('admin-current-tab', JSON.stringify(6));
              }}
            >
              <TabIcon className="fas fa-user-tie" /> Add new staff
            </TabStyle>
          )}
          {showAdditionalTabs && (
            <TabStyle
              isActive={tabIndex === 7}
              onClick={() => {
                setTabIndex(7);
                localStorage.setItem('admin-current-tab', JSON.stringify(7));
              }}
            >
              <TabIcon className="fas fa-exclamation-circle" /> Missing Courses
            </TabStyle>
          )}
          {showAdditionalTabs && (
            <TabStyle
              isActive={tabIndex === 4}
              onClick={() => {
                setTabIndex(4);
                localStorage.setItem('admin-current-tab', JSON.stringify(4));
              }}
            >
              <TabIcon className="fas fa-file-invoice-dollar" /> Payment Report
            </TabStyle>
          )}
          {showAdditionalTabs && (
            <TabStyle
              isActive={tabIndex === 5}
              onClick={() => {
                setTabIndex(5);
                localStorage.setItem('admin-current-tab', JSON.stringify(5));
              }}
            >
              <TabIcon className="fas fa-cog" /> Settings
            </TabStyle>
          )}
        </div>
        <button
          className="bg-white text-red-600 font-bold text-center
           rounded-lg border border-red-600 absolute
           left-24 bottom-6 px-5 py-2 hover:bg-red-600 hover:text-white"
          onClick={logout}
        >
          Logout
        </button>
      </SideBarWrap>
      {tabIndex === 0 && (
        <div className="px-4 2xl:px-8 w-full">
          <Dashboard />
        </div>
      )}
      {tabIndex === 1 && (
        <div className="px-4 2xl:px-8 w-full">
          <SignedInvigilatorRecords />
        </div>
      )}
      {tabIndex === 2 && (
        <div className="px-4 2xl:px-8 w-full">
          <AttendanceSheets />
        </div>
      )}
      {tabIndex === 3 && (
        <div className="px-4 2xl:px-8 w-full">
          <AddStudent />
        </div>
      )}
      {tabIndex === 4 && (
        <div className="px-4 2xl:px-8 w-full">
          <Payment />
        </div>
      )}
      {tabIndex === 5 && (
        <div className="px-4 2xl:px-8 w-full">
          <Settings />
        </div>
      )}
      {tabIndex === 6 && (
        <div className="px-4 2xl:px-8 w-full">
          <AddNewStaff />
        </div>
      )}
      {tabIndex === 7 && (
        <div className="px-4 2xl:px-8 w-full">
          <MissingCourseReport />
        </div>
      )}
    </PageWrapper>
  );
};
